/* @flow */
import SchoolViewContainer from './SchoolViewContainer';

export default SchoolViewContainer;
